import { EMAIL_REGEX } from "@common/controls/Form/Field/lib";

export const isEmailValid = (value: string) => value.match(EMAIL_REGEX);
